import React from 'react';
import axios from 'axios';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { API } from '@/utils/api';

const loadClient = async (id) => {
  const [c, v] = await Promise.all([axios.get(`${API}/clients/${id}`), axios.get(`${API}/vehicles`, { params: { client_id: id } })]);
  return { ...c.data, vehicles: v.data };
};

export const DuplicatesPanel = ({ dups, onUse, onIgnore, onBack }) => (
  <section className="space-y-3" data-testid="duplicates-panel">
    <div className="flex items-center gap-2 text-amber-700 font-semibold"><AlertTriangle className="w-4 h-4" />Ce client existe peut-être déjà</div>
    {dups.clients.map(c => (
      <div key={c.id} className="flex items-center gap-2 p-3 rounded-lg border" data-testid={`duplicate-client-${c.id}`}>
        <div className="flex-1 text-sm"><p className="font-semibold">{c.name}</p><p className="text-xs text-slate-500">{[c.phone, c.email, c.city].filter(Boolean).join(' · ')} · <span className="text-amber-700">{c.reason}</span></p></div>
        <Button size="sm" onClick={async () => onUse(await loadClient(c.id))} data-testid={`use-duplicate-${c.id}`}>Utiliser</Button>
      </div>
    ))}
    {dups.vehicles.map(v => (
      <div key={v.id} className="flex items-center gap-2 p-3 rounded-lg border bg-slate-50" data-testid={`duplicate-vehicle-${v.id}`}>
        <div className="flex-1 text-sm"><p className="font-semibold">{v.brand} {v.model} · {v.plate}</p><p className="text-xs text-amber-700">Véhicule déjà enregistré ({v.reason})</p></div>
        {v.client_id && <Button size="sm" variant="outline" onClick={async () => onUse(await loadClient(v.client_id), v.id)} data-testid={`use-duplicate-vehicle-${v.id}`}>Ouvrir son client</Button>}
      </div>
    ))}
    <div className="flex gap-2">
      <Button variant="outline" onClick={onBack} data-testid="duplicates-back-btn">Corriger</Button>
      <Button variant="outline" className="ml-auto" onClick={onIgnore} data-testid="duplicates-ignore-btn">Non, c'est un nouveau client</Button>
    </div>
  </section>
);
